var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrootHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29411",
    "data-name": "Group 29411",
    transform: "translate(-154 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(154 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29405",
    "data-name": "Group 29405",
    transform: "translate(173 428.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50236",
    "data-name": "Path 50236",
    d: "M13.728,5.72h-.47A2.328,2.328,0,0,0,12.6,4.029l.329-.329A2.718,2.718,0,0,1,13.728,5.72Z",
    transform: "translate(-9.969 -1.961)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50237",
    "data-name": "Path 50237",
    d: "M14.47,6.6H14V5.19A5.184,5.184,0,0,1,15.222,2.7l.376.282A4.706,4.706,0,0,0,14.47,5.19Z",
    transform: "translate(-10.711 -1.431)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50238",
    "data-name": "Path 50238",
    d: "M9.516,8.229,8.2,11.987c.329,1.081.752,1.785.846,2.349a23.185,23.185,0,0,0,.94,4.7c.7,1.832.987,2.866,2.349,3.759s1.973,1.41,2.819,1.41a5.38,5.38,0,0,0,3.289-1.41,15.442,15.442,0,0,0,2.349-2.819A17.635,17.635,0,0,0,22.671,13.4a10.912,10.912,0,0,0-1.41-5.638L17.5,4l-2.349.94L14.214,4s-.141.094-.329.235L13.744,5.41Z",
    transform: "translate(-7.636 -2.121)",
    fill: "#a1887f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50239",
    "data-name": "Path 50239",
    d: "M13.249,4.5l.329,1.551A.693.693,0,0,1,13.2,6.8l-.141.047a.693.693,0,0,0-.376.752l.47,2.772-1.41-2.349-1.41,3.759A9.269,9.269,0,0,1,9.4,8.494a14.313,14.313,0,0,1-1.785,3.759,9.616,9.616,0,0,1-.423-2.443C7,7.554,7,6.614,7,6.614l2.255-.752.611.752-.047.47h.47l.94-1.41h.282l.188.47.47-.47C12.215,5.346,12.873,4.782,13.249,4.5Z",
    transform: "translate(-7 -2.386)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50240",
    "data-name": "Path 50240",
    d: "M30.987,3.759c0,2.819-.235,4.652-.47,7.518,0,.047-.235-1.6-.376-2.3a2.842,2.842,0,0,0-.376-.987L28.309,5.779a.813.813,0,0,0-1.363-.094l-.658.893V4.886a.916.916,0,0,0-.047-.376l-.329-1.6a.659.659,0,0,0-.658-.564h-.141a.808.808,0,0,0-.8.658L23.47,7.518,23,3.759l.47-1.41c0-1.41.94-1.41.94-1.41l.47-.94.47.94.658-.611.282.141c.517.376.47.376.47,1.41a15.435,15.435,0,0,0,.47,2.349s.376-1.034.47-1.41A7.017,7.017,0,0,1,28.638.94s.141.094.611.376a1.814,1.814,0,0,1,.8,1.5v.94l.752-.282A2.149,2.149,0,0,1,30.987,3.759Z",
    transform: "translate(-15.483)",
    fill: "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50241",
    "data-name": "Path 50241",
    d: "M23.229,27.691A2.452,2.452,0,0,0,20.974,26c-1.363,0-1.879,1.644-1.879,1.691l-.047.188.047.141a2.121,2.121,0,0,0,1.879,1.269,2.381,2.381,0,0,0,2.208-1.222l.094-.188Zm-7.048,0A2.452,2.452,0,0,0,13.926,26c-1.363,0-1.879,1.644-1.879,1.691L12,27.879l.047.141a2.121,2.121,0,0,0,1.879,1.269,2.381,2.381,0,0,0,2.208-1.222l.094-.188Z",
    transform: "translate(-9.651 -13.784)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50242",
    "data-name": "Path 50242",
    d: "M11.979,4.229l.423.47c-.94,1.41-.94,5.638-.94,5.638l-.47-3.618a3.145,3.145,0,0,1,.517-1.926ZM17.1,2.349V4.229a2.747,2.747,0,0,1-.188.893L16.3,6.343a.947.947,0,0,0-.141.517v1.6l-.423-1.5a1.209,1.209,0,0,1,.047-.7l.658-1.5a1.2,1.2,0,0,0,0-.987L15.69,1.879A4.733,4.733,0,0,0,17.1,2.349Zm4.229.47V7.048l-.47-1.41-.282.282a1.11,1.11,0,0,0-.282.423l-.846,2.114V7.8a5.656,5.656,0,0,1,.7-2.772,1.943,1.943,0,0,0,.235-.893V1.879C20.389,2.913,21.094,3.712,21.329,2.819ZM19.637.329l-.752,2.3a9.546,9.546,0,0,0-.47,2.3L18.04,9.4V4.37a5.358,5.358,0,0,1,.094-1.222L18.509,0A4.383,4.383,0,0,1,19.637.329ZM24.43,3.477A2.96,2.96,0,0,1,24.007,4.6a5.243,5.243,0,0,0-.8,2.725V9.867l-.423-3.054a4.807,4.807,0,0,1,.235-2.161l.658-1.832A3.85,3.85,0,0,1,24.43,3.477ZM14.751,6.86V9.4l-.423-2.49A1.123,1.123,0,0,0,14,6.3l-.188-.188-.141.235A3.148,3.148,0,0,0,13.341,7.8V8.927l-.376-1.081a3.07,3.07,0,0,1,0-1.6l.282-1.081.376-1.879h.658V5.356a1.071,1.071,0,0,0,.141.517l.235.47A1.689,1.689,0,0,1,14.751,6.86Z",
    transform: "translate(-9.113)",
    fill: "#8d6e63"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28959",
    "data-name": "Group 28959",
    transform: "translate(1.691 0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50243",
    "data-name": "Path 50243",
    d: "M12.057,2.081C11.775,1.658,10.6,1.47,10.6,1.47s.376.7.7,1.175a.542.542,0,0,0,.7.188A.571.571,0,0,0,12.057,2.081Zm1.175-.47c.329-.423,1.5-.611,1.5-.611s-.376.7-.7,1.175a.542.542,0,0,1-.7.188A.576.576,0,0,1,13.231,1.611Z",
    transform: "translate(-10.6 -1)",
    fill: "#689f38"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50244",
    "data-name": "Path 50244",
    d: "M20,39.183a8.8,8.8,0,0,1,1.691-.094,17.876,17.876,0,0,0,2.067.329,2.329,2.329,0,0,1-1.879,1.034A1.945,1.945,0,0,1,20,39.183Z",
    transform: "translate(-13.892 -20.718)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28960",
    "data-name": "Group 28960",
    transform: "translate(2.819 12.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50245",
    "data-name": "Path 50245",
    d: "M23.337,28.363A2.056,2.056,0,0,0,21.5,27c-1.081,0-1.457,1.363-1.457,1.363a1.682,1.682,0,0,0,1.457.987A1.99,1.99,0,0,0,23.337,28.363Zm-7.048,0A2.056,2.056,0,0,0,14.457,27C13.376,27,13,28.363,13,28.363a1.682,1.682,0,0,0,1.457.987A1.99,1.99,0,0,0,16.289,28.363Z",
    transform: "translate(-13 -27)",
    fill: "#490c0c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28961",
    "data-name": "Group 28961",
    transform: "translate(3.195 12.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50246",
    "data-name": "Path 50246",
    d: "M23.432,28.122a1.483,1.483,0,0,1-.329.893,2.534,2.534,0,0,1-1.175.282,1,1,0,0,1-.564-.141,1.274,1.274,0,0,1-.517-1.081,1.351,1.351,0,0,1,.329-.846h0a1.133,1.133,0,0,1,.8-.329,1.706,1.706,0,0,1,1.363.611A3.234,3.234,0,0,1,23.432,28.122Zm-7.048,0a1.483,1.483,0,0,1-.329.893,2.534,2.534,0,0,1-1.175.282,1,1,0,0,1-.564-.141,1.274,1.274,0,0,1-.517-1.081,1.351,1.351,0,0,1,.329-.846h0a1.133,1.133,0,0,1,.8-.329,1.706,1.706,0,0,1,1.363.611A3.234,3.234,0,0,1,16.384,28.122Z",
    transform: "translate(-13.8 -26.9)",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28962",
    "data-name": "Group 28962",
    transform: "translate(3.759 13.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50247",
    "data-name": "Path 50247",
    d: "M22.518,28a.47.47,0,1,0,.47.47A.47.47,0,0,0,22.518,28ZM15.47,28a.47.47,0,1,0,.47.47A.47.47,0,0,0,15.47,28Z",
    transform: "translate(-15 -28)",
    fill: "#e0e0e0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrootHighlighted);
export default __webpack_public_path__ + "static/media/grootHighlighted.dedc77f5e402702a5abdfbb2e49cd2e7.svg";
export { ForwardRef as ReactComponent };